import { render, staticRenderFns } from "./application.vue?vue&type=template&id=b0a0b258&scoped=true&lang=pug"
import script from "./application.vue?vue&type=script&lang=js"
export * from "./application.vue?vue&type=script&lang=js"
import style0 from "./application.vue?vue&type=style&index=0&id=b0a0b258&prod&lang=scss&scoped=true"
import style1 from "./application.vue?vue&type=style&index=1&id=b0a0b258&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a0b258",
  null
  
)

export default component.exports